import { sectionIds, setup, stage } from '../config';
const { currentStage } = setup;

const navSection = [{
    text: '罷免懶人包',
    anchorId: sectionIds.takeAway,
    disable: false,
  },
  {
    text: '開票結果',
    anchorId: sectionIds.graphic,
    disable: currentStage === stage.history ? false : true,
  },
  {
    text: '延伸閱讀',
    anchorId: sectionIds.more,
    disable: false,
  },
]

const landingText = '<p>中華民國史上首次直轄市長罷免案投票，6月6日將揭曉選舉結果。最終高雄市民的選擇是什麼？開票過程發生哪些關鍵事件？</p><p>《P#新聞實驗室》依據中選會資料，即時更新開票進度，與您共同關心歷史一刻。（註：選舉結果以中選會公告為準）</p>'
const landingTextpostLive = '<p>中華民國史上首次直轄市長罷免案投票，在6月6日落幕。最終韓國瑜獲得同意票數93萬9090票、不同意票2萬5051票。</p><p>罷免案開票期間發生哪些關鍵事件？對高雄市政未來將產生哪些影響？《P#新聞實驗室》與你一起關心歷史一刻。（註：選舉結果以中選會公告為準）</p>'

const editorText = {
  landing: currentStage <= stage.live ? landingText:landingTextpostLive,
}

const people = [
  {
    name: '卓冠齊',
    title: '製作人',
  },
  {
    name: '吳亭霓、卓冠齊',
    title: '企劃',
  },
  {
    name: '簡毅慧、林建勳、吳亭霓、Nagao Kunaw',
    title: '編輯',
  },
  {
    name: '曾芯敏',
    title: '設計',
  },
  {
    name: '曾涵郁、陳柏偉',
    title: '工程',
  },
  {
    name: 'Nagao Kunaw',
    title: '社群',
  }
];


const moreData = [
  {
    title: '《數說韓流》韓國瑜正式退場　回顧韓流的網路空戰史',
    date: '06/10',
    imgUrl: 'https://server.newslab.pts.org.tw/uploads/News/218/5edf631ef2612.png',
    externalLink: 'https://newslab.pts.org.tw/news/218',
  },
  {
    title: '《罷免案》高票數遭罷免　韓國瑜補助款不需繳回',
    date: '06/07',
    imgUrl: 'https://server.newslab.pts.org.tw/uploads/News/220/5edc980688c60.jpg',
    externalLink: 'https://newslab.pts.org.tw/news/220',
  },
  {
    title: '《罷免案》韓國瑜遭罷免創首例　都是「罷韓國家隊」的錯？',
    date: '06/06',
    imgUrl: 'https://server.newslab.pts.org.tw/uploads/News/219/5edb831b8f27b.png',
    externalLink: 'https://newslab.pts.org.tw/news/219',
  },
  {
    title: '《罷免案》高雄市長罷免案　回顧台灣的選舉罷免史',
    date: '06/04',
    imgUrl: 'https://server.newslab.pts.org.tw/uploads/News/214/5ed876366bcb5.jpg',
    externalLink: 'https://newslab.pts.org.tw/news/214',
  },
  {
    title: '《罷免案》韓國瑜的政治路　從庶民到落選總統',
    date: '06/03',
    imgUrl: 'https://server.newslab.pts.org.tw/uploads/News/213/5ed65285f206b.jpg',
    externalLink: 'https://newslab.pts.org.tw/news/213',
  },
  {
    title: '《P觀點》市長不在家　掀起高雄罷韓潮',
    date: '06/01',
    imgUrl: 'https://img.youtube.com/vi/IqdbAGH3wVA/maxresdefault.jpg',
    externalLink: 'https://youtu.be/IqdbAGH3wVA',
  },
  {
    title: '《P觀點》罷韓嗎？高雄市民的第一堂民主課',
    date: '05/29',
    imgUrl: 'https://img.youtube.com/vi/fLLfPK2qlh8/maxresdefault.jpg',
    externalLink: 'https://youtu.be/fLLfPK2qlh8',
  },
  {
    title: '《獨立特派員》罷免這件事',
    date: '05/27',
    imgUrl: 'https://img.youtube.com/vi/fO6lSda6w5Y/maxresdefault.jpg',
    externalLink: 'https://innews.pts.org.tw/video/MTU3MQ',
  },
  {
    title: '《有話好說》6/6罷韓有話好說》投票！通過門檻57.5萬票！',
    date: '05/21',
    imgUrl: 'https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/more-talk-news.png',
    externalLink: 'http://talk.news.pts.org.tw/show/15682',
  },
];

const dataForTakeaway = [
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-s1-1.jpg",
    title: "為什麼要罷免高雄市長？",
    text: "領銜人陳冠榮提出罷韓理由共五點，包括高雄市長韓國瑜違反責任政治及誠信、市政滿意度低、市政停擺、紅媒介入「韓流」，以及韓國瑜屢次發表歧視性言論等。（資料來源：中選會）",
    external: [{
      title: '《完整資訊》',
      content: '中選會公告之罷免理由書',
      href: 'https://www.cec.gov.tw/central/cms/bulletin/33146?utm_source=Facebook_PicSee',
    }],
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-s1-2.jpg",
    title: "誰可以投票罷免高雄市長？",
    text: "只要在6月5日年滿20歲，且設籍高雄市滿四個月以上，就能拿到罷免選票。特別的是，在這次選舉中，首度行使公民權的「首投族」，同時也是「罷免首投族」，手上第一張選票就是罷免票。<br/>除此之外，依據《勞基法》第37條，具有投票資格者，投票當天屬於法定假日。（資料來源：中選會）",
    external: [{
      title: '《完整資訊》',
      content: '中選會公告罷免投票日為假日',
      href: 'https://www.cec.gov.tw/central/cms/bulletin/33193',
    }]
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-s1-3.jpg",
    title: "罷免案通過的門檻是什麼？",
    text: "根據《選罷法》，若超過1/4的人投下有效同意票，且票數多於不同意票，罷免案就會通過。<br />本次罷免投票的選舉人數為229萬9981人，換算比例，罷免案通過的門檻為57萬4996張有效同意票。（資料來源：中選會）",
    external: [{
      title: '《延伸閱讀》',
      content: '罷免門檻的修法歷史',
      href: 'https://server.newslab.pts.org.tw/uploads/img/redactor/20200604/5ed870c8474f9.jpg',
    }]
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-s1-4.jpg",
    title: "如果罷免案通過了⋯⋯",
    text: "根據《選罷法》，在選委會公告罷免案通過後，將解除高雄市長職務，並由行政院派任代理市長，且需於三個月內完成補選。而無論是補選或下一屆市長選舉，韓國瑜都無法參選。<br />除此之外，由於罷免已經成立，韓國瑜若在罷免投票前或過程中辭職，同樣無法在2024年6月前，再次參選高雄市長一職。（資料來源：中選會）",
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-s1-5.jpg",
    title: "如果罷免案通過了⋯⋯",
    text: "若投票結果為通過，韓國瑜在30天內可提起罷免訴訟，法院需在6個月內審理結束。<br />而高雄市長韓國瑜在2018年12月25日就職，法定任期為四年，至罷免投票已逾一年六個月。<br/>若罷免訴訟一審勝訴，韓國瑜將有機會重回市長寶座。但訴訟若拖過今年12月25日，因高雄市長市長剩餘任期不滿兩年，不會進行補選，將由行政院派任的代理市長完成剩餘任期。（資料來源：中選會）",
    external: [
      {
        title: '《延伸閱讀》',
        content: '訴訟日程表',
        href: 'https://server.newslab.pts.org.tw/uploads/img/redactor/20200604/5ed87122d1186.jpg',
      },
      {
        title: '《延伸閱讀》',
        content: '罷免法規變遷歷史',
        href: 'https://server.newslab.pts.org.tw/uploads/img/redactor/20200604/5ed86e3490b78.jpg',
      },
    ]
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-s1-6.jpg",
    title: "如果罷免案沒有通過⋯⋯",
    text: "高雄市長罷免案若未通過，韓國瑜將繼續擔任高雄市長。而在這屆高雄市長法定任期中，將無法再度提出市長罷免案。<br/>韓國瑜先生仍是高雄市的市長，將會完成任期到2022年12月底。",
    external: [{
      title: '延伸閱讀',
      content: '還有誰被罷免過？',
      href: 'https://server.newslab.pts.org.tw/uploads/img/redactor/20200604/5ed8701b22c53.jpg',
    }]
  },
]

const dataForResult = [
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-result-1.jpg",
    title: "",
    text: "高雄市長罷免案中，最終同意票93萬9090票、不同意票2萬5051票，中選會6日公布罷免投票結果「通過」。<br><br>韓國瑜確定需離開市長寶座，也成為中華民國史上首位被罷免的直轄市長。<br><br>（資料來源：中選會、高雄市選委會）<br><br>",
    external: [
      {
        title: '《完整資訊》',
        content: '高票數遭罷免　韓國瑜補助款不需繳回',
        href: 'https://newslab.pts.org.tw/news/220-%E9%AB%98%E7%A5%A8%E6%95%B8%E9%81%AD%E7%BD%B7%E5%85%8D%E3%80%80%E9%9F%93%E5%9C%8B%E7%91%9C%E8%A3%9C%E5%8A%A9%E6%AC%BE%E4%B8%8D%E9%9C%80%E7%B9%B3%E5%9B%9E',
      },
      {
        title: '《延伸閱讀》',
        content: '韓國瑜遭罷免創首例　都是「罷韓國家隊」的錯？',
        href: 'https://newslab.pts.org.tw/news/219-%E9%9F%93%E5%9C%8B%E7%91%9C%E9%81%AD%E7%BD%B7%E5%85%8D%E5%89%B5%E9%A6%96%E4%BE%8B%20%E9%83%BD%E6%98%AF%E3%80%8C%E7%BD%B7%E9%9F%93%E5%9C%8B%E5%AE%B6%E9%9A%8A%E3%80%8D%E7%9A%84%E9%8C%AF%EF%BC%9F',
      }
    ],
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-result-2.jpg",
    title: "",
    text: "對比韓國瑜2018當選市長得票數，高雄38個行政區中，有23區罷免同意票超過韓國瑜當時選舉得票。而票數差異最大的地方為三民區、小港區與前鎮區。<br><br>（資料來源：中選會、高雄市選委會）",
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-result-3.jpg",
    title: "",
    text: "對比韓國瑜2018當選市長得票數，高雄38個行政區中，有23區罷免同意票超過韓國瑜當時選舉得票。而票數差異最大的地方為三民區、小港區與前鎮區。<br><br>（資料來源：中選會、高雄市選委會）",
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-result-4.jpg",
    title: "",
    text: "剩餘15個行政區中，罷免同意票未超過韓國瑜當時得票，包含2018市長選舉韓營造勢重鎮，岡山、鳳山、旗山等行政區。<br><br>（資料來源：中選會、高雄市選委會）",
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-result-5-1.jpg",
    title: "",
    text: "這次投票中，茂林區、桃源區及那瑪夏區，投票率都不到10％，與2018地方選舉相比，投下罷免票的民眾相對少很多。<br><br>其中茂林區是投票率差異最大的地區，僅有4％的選民出來投罷免票，對比2018年92％的投票率，差距近九成。<br><br>（資料來源：中選會、高雄市選委會）",
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-result-5-2.jpg",
    title: "",
    text: "這次投票中，茂林區、桃源區及那瑪夏區，投票率都不到10％，與2018地方選舉相比，投下罷免票的民眾相對少很多。<br><br>其中茂林區是投票率差異最大的地區，僅有4％的選民出來投罷免票，對比2018年92％的投票率，差距近九成。<br><br>（資料來源：中選會、高雄市選委會）",
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-result-5-3.jpg",
    title: "",
    text: "橋頭區是罷免結果中，投票率最高的地區，同時也是與2018地方選舉相較之下，投票率差異最小的地區。而其他投票率較相近的地區還有大社區、梓官區以及仁武區等。<br><br>（資料來源：中選會、高雄市選委會）",
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-result-6.jpg",
    title: "",
    text: "總體而言，這次罷免投票中，有效票分別為同意票93萬9090票、不同意票2萬5051票。換算比例，約有97.4%為同意票，而各地區同意票佔比都超過89%。<br><br>茂林區同意佔比最高達98.4％，但同時也是全高雄投票率最低的地區，僅有4%的民眾出來投票。<br><br>（資料來源：中選會、高雄市選委會）",
  },
  {
    src: "https://d3prffu8f9hpuw.cloudfront.net/recall-vote-han-kuo-yu/carousel-result-7.jpg",
    title: "",
    text: "而桃源區的225張有效票，其中有24票為不同意罷免，不同意得票率10.7％，不同意票得票率為全高雄市最高。第二高則是六龜區的5.4％，其他區域不同意票得票率皆低於5%。<br><br>（資料來源：中選會、高雄市選委會）",
  },
];


export {
  navSection,
  editorText,
  people,
  moreData,
  dataForTakeaway,
  dataForResult
}
